import { useTranslation } from "react-i18next";
import AppHandoff from "../../ui/AppHandoff";
import useDocumentTitle from "../../../hook/useDocumentTitle";

// Reached via the universal link
// https://launchpad.saltplatform.com/app/church/{churchID}/team/{teamID}.
//
// The app does the joining: it opens on the inviting church and asks the
// person to sign in (VolunteerTeamInviteCoordinator in Salt-iOS). So this page
// only has to get the app installed and send them back to the link.

const STEPS = ["download", "reopen", "signIn"] as const;

export default function TeamInvite() {
  const { t } = useTranslation("teamInvite");
  useDocumentTitle(t("documentTitle"));

  return <AppHandoff heading={t("heading")} instructions={t("instructions")}>
    <ol className="flex flex-col gap-3 w-full max-w-sm">
      {STEPS.map((step, index) => <li key={step} className="flex items-center gap-3">
        <span className="shrink-0 size-8 rounded-full bg-gray-100 text-gray-600 font-semibold flex items-center justify-center">
          {index + 1}
        </span>
        <span className="text-gray-700">{t(`steps.${step}`)}</span>
      </li>)}
    </ol>
  </AppHandoff>
}
